import { render, staticRenderFns } from "./AdminCertificates.vue?vue&type=template&id=f96a752a"
import script from "./AdminCertificates.vue?vue&type=script&lang=ts"
export * from "./AdminCertificates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports